import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";
import toast, { Toaster } from "react-hot-toast";

const AssignOrder = () => {
  const Navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const userId = searchParams.get("user_id"); // 👈 yeh tumhara user_id hai
  let is_alert = false;

  useEffect(() => {
    // return()=>{
    if (location.state !== null) {
      if (is_alert === false) {
        toast.success(location.state);
      }

      is_alert = true;
    }
    window.history.replaceState({}, location.state);

    // }
  }, []);

  const [data, setData] = useState([]);
  const [totalpage, setTotalPage] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const perPage = 10; // 👈 Number of items per page
  const [statusFilter, setStatusFilter] = useState("Pending");

  const handlePageClick = (e) => {
    setPage(e.selected + 1);
  };

  const AssignCodeData = () => {
    axios
      .get(
        `${process.env.REACT_APP_URL}/admin/assigned-orders/get?page=${page}&search=${search}&status=${statusFilter}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        }
      )
      .then((res) => {
        const fullData = res?.data?.data?.desc || [];

        const filteredData = fullData.filter((item) => {
          return (
            item.order_id === parseInt(userId) &&
            (statusFilter ? item.orderStatus === statusFilter : "")
          );
        });
        setData(filteredData);

        const totalPages = Math.ceil(filteredData.length / perPage);
        setTotalPage(totalPages);
      })
      .catch((err) => {
        if (err?.response?.data?.message === "Unauthorized!") {
          Navigate("/");
        }
      });
  };

  const HandleActiveDeactive = (id, status) => {
    let statusText = "";
    let Color = "";
    if (status === true) {
      statusText = "Deactive";
      Color = "#DC3741";
    } else {
      statusText = "Active";
      Color = "#1b55e2";
    }

    Swal.fire({
      title: `Do you want to ${statusText} this Record?`,
      icon: "error",
      showCancelButton: true,
      confirmButtonColor: Color,
      confirmButtonText: statusText,
    }).then((result) => {
      if (result.isConfirmed === true) {
        axios
          .post(
            `${process.env.REACT_APP_URL}/admin/assigned-orders/change-status`,
            {
              id: id,
              status: status ? false : true,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("Token")}`,
              },
            }
          )
          .then((res) => {
            if (res.status === 200) {
              toast.success(res.data.message);
              AssignCodeData();
            }
          })
          .catch((err) => {

            const MSG = ["Token not found.", "Invalid token.", "Unauthorized."];
            const STATUS = [401, 403];
            if (
              STATUS.includes(err?.response?.status) ||
              MSG.includes(err?.response?.data?.msg)
            ) {
              localStorage.clear();
              Navigate("/admin/login");
            } else {
              toast.error(err?.response?.data?.msg);
            }
          });
      }
    });
  };

  const HandleDelete = (e) => {
    Swal.fire({
      title: "Do you want to Delete this Record?",
      icon: "error",
      showCancelButton: true,
      confirmButtonColor: "#DC3741",
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed === true) {
        axios
          .delete(
            `${process.env.REACT_APP_URL}/admin/assigned-orders/delete?id=${e}`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("Token")}`,
              },
            }
          )
          .then((res) => {
            if (res?.status === 200) {
              Swal.fire({
                title: "Deleted Sucessfully.",
                icon: "success",
                showConfirmButton: false,
                timer: 2000,
              });
              AssignCodeData();
            }
          })
          .catch((err) => {

            const MSG = ["Token not found.", "Invalid token.", "Unauthorized."];
            const STATUS = [401, 403];
            if (
              STATUS.includes(err?.response?.status) ||
              MSG.includes(err?.response?.data?.msg)
            ) {
              localStorage.clear();
              Navigate("/admin/login");
            } else {
              toast.error(err?.response?.data?.msg);
            }
          });
      }
    });
  };

  useEffect(() => {
    AssignCodeData();
  }, [page, search, statusFilter]);

  const initialsOf = (name = "") =>
    name.trim().split(/\s+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase() || "?";
  const TINTS = [
    { bg: "var(--color-info-bg)", color: "var(--color-info-text)" },
    { bg: "var(--color-success-bg)", color: "var(--color-success-text)" },
    { bg: "var(--color-violet-bg)", color: "var(--color-violet-text)" },
    { bg: "var(--color-warning-bg)", color: "var(--color-warning-text)" },
  ];
  const tint = (s = "") => TINTS[(String(s).length) % TINTS.length];
  const statusTint = (st = "") => {
    if (st === "Assigned") return { bg: "var(--color-success-bg)", color: "var(--color-success-text)" };
    if (st === "Completed") return { bg: "var(--color-primary-weak)", color: "var(--color-primary)" };
    if (st === "In Progress") return { bg: "var(--color-info-bg)", color: "var(--color-info-text)" };
    if (st === "Pending") return { bg: "var(--color-warning-bg)", color: "var(--color-warning-text)" };
    if (st === "Rejected") return { bg: "var(--color-danger-bg)", color: "var(--color-danger-text)" };
    return { bg: "var(--color-surface-2)", color: "var(--color-text-secondary)" };
  };

  const [dense, setDense] = useState(false);
  const [isMobileView, setIsMobileView] = useState(typeof window !== "undefined" && window.innerWidth < 768);
  useEffect(() => {
    const h = () => setIsMobileView(window.innerWidth < 768);
    window.addEventListener("resize", h);
    return () => window.removeEventListener("resize", h);
  }, []);

  const TABS = ["Pending", "Assigned", "Completed", "Rejected"];
  const money = (v) => (v || v === 0) && v !== null && v !== "" ? `₹${Number(v).toLocaleString("en-IN")}` : "—";
  const fmt = (d) =>
    d ? new Date(d).toLocaleString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false }) : "—";

  const ViewBtn = ({ item }) => (
    <div className="al-actions">
      <button type="button" className="al-act" title="View"
        onClick={() => Navigate("/admin/buyer/show", { state: { id: item?.id, name: item?.name, email: item?.email, status: item?.is_active } })}>
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
      </button>
    </div>
  );

  const GRID = { gridTemplateColumns: "80px 80px 1.2fr 1.3fr 1.1fr 1.1fr .9fr 1fr 100px" };

  return (
    <div className="al">
      <Toaster position="top-center" reverseOrder={false} />

      <div className="al-head">
        <div>
          <h1 className="al-title">Assigned Orders</h1>
          <p className="al-sub">Orders assigned to suppliers and their production status.</p>
        </div>
        <div className="al-head__actions">
          <button type="button" className="al-btn" onClick={() => Navigate(-1)}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
            Back
          </button>
        </div>
      </div>

      <div className="al-tabs">
        {TABS.map((t) => (
          <button key={t} type="button"
            className={`al-tab ${statusFilter === t ? "is-active" : ""}`}
            onClick={() => setStatusFilter(t)}>
            {t}
          </button>
        ))}
      </div>

      <div className="al-card">
        <div className="al-toolbar">
          <div className="al-search">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--color-text-tertiary)" strokeWidth="2" strokeLinecap="round"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg>
            <input type="search" placeholder="Search by order ID, product title…"
              onKeyDown={(e) => e.key === "Enter" && search !== "" && AssignCodeData()}
              onChange={(e) => setSearch(e.target.value)} />
          </div>
          <button type="button" className="al-tool" style={{ marginLeft: "auto" }} onClick={() => setDense((d) => !d)} title="Toggle density">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
            {dense ? "Comfortable" : "Density"}
          </button>
        </div>

        {!isMobileView ? (
          <div className="al-tablewrap">
            <div style={{ minWidth: 1120, "--al-row-pad": dense ? "8px" : "13px" }}>
              <div className="al-thead" style={GRID}>
                <span className="al-th">Order Id</span>
                <span className="al-th">Supplier Id</span>
                <span className="al-th">Supplier Name</span>
                <span className="al-th">Product Name</span>
                <span className="al-th">Supplier Quote</span>
                <span className="al-th">Quotation for Buyer</span>
                <span className="al-th">Status</span>
                <span className="al-th">Date &amp; Time</span>
                <span className="al-th al-th--right">Action</span>
              </div>

              {data && data.length > 0 ? (
                data.map((item, index) => {
                  const t = tint(item?.userData?.name);
                  const st = statusTint(item?.orderStatus);
                  return (
                    <div className="al-row" style={GRID} key={index}>
                      <span className="al-mono" style={{ color: "var(--color-primary)", fontWeight: 700 }}>#{parseInt(item?.order_id)}</span>
                      <span className="al-mono al-muted">{parseInt(item?.supplier_id)}</span>
                      <div className="al-id">
                        <span className="al-avatar" style={{ background: t.bg, color: t.color }}>{initialsOf(item?.userData?.name)}</span>
                        <span className="al-name">{item?.userData?.name}</span>
                      </div>
                      <span className="al-muted al-ellipsis" title={item?.productdata?.title}>{item?.productdata?.title}</span>
                      <span className="al-mono" style={{ fontWeight: 700 }}>{money(item?.quotation_price)}</span>
                      <span className="al-mono" style={{ fontWeight: 700, color: "var(--color-primary)" }}>{money(item?.admin_quotation_price ?? item?.final_price)}</span>
                      <span>
                        <span className="al-pill" style={{ background: st.bg, color: st.color }}>{item?.orderStatus}</span>
                      </span>
                      <span className="al-mono al-muted">{fmt(item?.created_at)}</span>
                      <ViewBtn item={item} />
                    </div>
                  );
                })
              ) : (
                <div className="al-empty">
                  <div className="al-empty__icon">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
                  </div>
                  <p className="al-empty__title">No Record Found</p>
                  <p className="al-empty__text">No {statusFilter?.toLowerCase()} orders to show.</p>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="al-mobile">
            {data && data.length > 0 ? (
              data.map((item, index) => {
                const t = tint(item?.userData?.name);
                const st = statusTint(item?.orderStatus);
                return (
                  <div className="al-mcard" key={index}>
                    <div className="al-mcard__top">
                      <span className="al-avatar" style={{ background: t.bg, color: t.color }}>{initialsOf(item?.userData?.name)}</span>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div className="al-name">{item?.userData?.name}</div>
                        <div className="al-mono al-muted" style={{ fontSize: 11 }}>Order #{parseInt(item?.order_id)}</div>
                      </div>
                      <span className="al-pill" style={{ background: st.bg, color: st.color }}>{item?.orderStatus}</span>
                    </div>
                    <div className="al-mrow"><span className="al-muted">Supplier Id</span><span className="al-mono">{parseInt(item?.supplier_id)}</span></div>
                    <div className="al-mrow"><span className="al-muted">Product</span><span>{item?.productdata?.title}</span></div>
                    <div className="al-mrow"><span className="al-muted">Supplier Quote</span><span className="al-mono">{money(item?.quotation_price)}</span></div>
                    <div className="al-mrow"><span className="al-muted">Quotation for Buyer</span><span className="al-mono" style={{ color: "var(--color-primary)" }}>{money(item?.admin_quotation_price ?? item?.final_price)}</span></div>
                    <div className="al-mrow"><span className="al-muted">Date</span><span className="al-mono al-muted">{fmt(item?.created_at)}</span></div>
                    <div className="al-mactions"><ViewBtn item={item} /></div>
                  </div>
                );
              })
            ) : (
              <div className="al-empty"><p className="al-empty__title">No Record Found</p></div>
            )}
          </div>
        )}

        <div className="al-foot">
          <span className="al-foot__info">Showing <strong>{data?.length || 0}</strong> orders</span>
          {data?.length !== 0 && (
            <ReactPaginate
              previousLabel={<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>}
              nextLabel={<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>}
              breakLabel={"..."}
              pageCount={totalpage}
              marginPagesDisplayed={2}
              pageRangeDisplayed={2}
              onPageChange={handlePageClick}
              containerClassName={"pagination justify-content-end m-0"}
              pageClassName={"page-item"} pageLinkClassName={"page-link"}
              previousClassName={"page-item"} previousLinkClassName={"page-link"}
              nextClassName={"page-item"} nextLinkClassName={"page-link"}
              breakClassName={"page-item"} breakLinkClassName={"page-link"}
              activeClassName={"active"} />
          )}
        </div>
      </div>
    </div>
  );
};

export default AssignOrder;
